
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/partners/[id]",
      function () {
        return require("private-next-pages/learn/partners/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/partners/[id]"])
      });
    }
  